class LoadRecaptcha {
	
	static runRecaptcha(errorCheck, formId, onSubmit, recaptchaKey) {
		/* eslint-disable */
		grecaptcha.ready(function () {
			/* eslint-enable */
			try {
				/* eslint-disable */
				grecaptcha.execute(recaptchaKey).then(function (token) {
					/* eslint-enable */
					const form = document.querySelector(formId);
					const captchaField = form.querySelector('input[name="captcha"]');
					captchaField.value = token;
					
					onSubmit();
					
				}, function (error) {
					
					throw error;
					
				})
			} catch (error) {
				errorCheck.openErrorModal();
			}
		});
	}
	
	/**
	 * Loading recaptcha at the same time with submitting form
	 * @param errorCheck
	 * @param formId - string (id of form)
	 * @param needRecaptcha - boolean if there is a need to have a recaptcha
	 * @param onSubmit
	 */
	static loadRecaptcha(errorCheck, formId, needRecaptcha, onSubmit) {
		if (needRecaptcha === false) {
			onSubmit();
			return;
		}
		
		const recaptchaKey = process.env.RECAPTCHA_KEY;
		const recaptchaUrl = `https://www.google.com/recaptcha/api.js?render=${ recaptchaKey }`;
		
		let script = document.createElement('script');
		script.src = recaptchaUrl;
		script.async = true;
		script.onload = () => {
			
			this.runRecaptcha(errorCheck, formId, onSubmit, recaptchaKey);
		}
		
		const scriptList = document.getElementsByTagName('script');
		
		const recaptchaScript = [...scriptList].find((script) => script.src === recaptchaUrl);
		
		if (!recaptchaScript) {
			document.body.appendChild(script);
		} else {
			this.runRecaptcha(errorCheck, formId, onSubmit, recaptchaKey);
		}
		
	}
}

module.exports = LoadRecaptcha;